export const WEBSOCKET_LOGS = false;
